module.exports = __webpack_public_path__ + "media/images/underline-7d4066ceb5d587b257d8ab89fa15a5d8.svg";